export enum CommandType {
    CreateNewEstimate,
    OpenEstimatesPopup,
    OpenCostbooksPopup,
    OpenCustomerInfoPopup,
    OpenCompanyInfoPopup,
    OpenAccountingSettingsPopup,
    OpenDefaultCompanyInfoPopup,
    OpenTaxRatesPopup,
    OpenMarkupsPopup,
    OpenPercentagesPopup,
    OpenAreaCostsModificationsPopup,
    OpenCostbookPropertiesPopup,
    OpenEstimateSaveAsPopup,
    OpenEstimateImportPopup,
    OpenEstimateExportPopup,


    RenameEstimate,
    RenameCurrentEstimate,
    
    RemoveEstimate,
    RemoveCurrentEstimate,

    PrintEstimate,
    ExportBid,
    ExportInvoice,

    CreateEstimateTextRow,
    EditEstimateTextRow,

    CreateEstimateCostRow,
    EditEstimateCostRow,

    CreateEstimateSubtotalRow,
    EditEstimateSubtotalRow,

    EditEstimateRow,
    
    RemoveEstimateRow,
    
    ChooseCost,

    CutRow,
    CopyRow,
    PasteRow,
    
    Undo,
    Redo,
    
    ShowSearchBar,
    ShowContentSearchBar,
    ShowIndexSearchBar,
    ShowBookmarksSearchBar,

    AddBookmark,
    RemoveBookmark,
    
    LogOut,

    OpenEstimateSettingsPopup,
    ImportEstimate,

    ShowEstimateUnitCosts,
    ShowEstimateDoubleSpaceLines,
    HideEstimateComponentCosts
}


// WEBPACK FOOTER //
// ./ClientApp/services/commandType.ts